import React from 'react'
import styled from 'styled-components'

export default function About() {

  return (
    <Wrapper>
      <h1>About HandyNoteBook</h1>
      <hr/>
      <p>The project is based on user notes. Here user can add, edit or delete his personal,professional and important notes etc. He needs to first signup or login before using iNoteBook. user can search for notes categorywise(Tags). User is advised not to share his password with anyone. </p>
      <p>For more project you can look forward on my Portfolio. If anyone wants to contact the page owner visit the website below. Hope you enjoy!</p>
      <a rel='noreferrer' target="_blank" href='https://bhushanvermaportfolio.netlify.app/'>Bhushan Verma(Admin) | &copy; All rights are reserved</a>
    </Wrapper>
  )
}

const Wrapper = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  h1{
    color: grey;
  }
  hr{
    width: 90%;
  }
  p{
    width: 80%;
  }
  a{
    margin-top: 8rem;
    color: blue;
    text-decoration: none;
    &:hover{
      text-decoration: underline;
      color: grey;
    }
  }
`